import styled from 'styled-components';

export const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-flow: row;
  column-gap: 10px;
  align-items: center;
  @media (hover: hover) {
    &:hover {
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    }
  }
`;

export const Circle = styled.div<{ checked?: boolean; disabled?: boolean }>`
  width: 48px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  flex-flow: row;
  background-color: ${({ checked, disabled, theme }) => {
    if (theme.isVaultVariant) {
      return checked
        ? theme.atlas.semantic.color.action.primary.default
        : theme.atlas.semantic.color.outline.default;
    }
    if (checked) {
      return disabled
        ? theme.atlas.semantic.color.action.primary.disabled
        : theme.atlas.semantic.color.action.primary.default;
    }
    return theme.atlas.semantic.color.surface.default;
  }};
  ${({ checked, disabled, theme }) =>
    theme.isVaultVariant
      ? ''
      : `border: 1px solid ${
          checked
            ? disabled
              ? theme.atlas.semantic.color.action.primary.disabled
              : theme.atlas.semantic.color.action.primary.default
            : disabled
              ? theme.atlas.semantic.color.outline.disabled
              : theme.atlas.semantic.color.outline.default
        }; box-sizing: border-box;`}
  ${({ disabled, theme }) =>
    disabled && theme.isVaultVariant ? 'opacity: 0.5;' : ''}
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  position: relative;

  @media (hover: hover) {
    &:hover {
      ${({ checked, disabled, theme }) => {
        if (theme.isVaultVariant || disabled) return '';
        const color = checked
          ? theme.atlas.semantic.color.action.primary.hover
          : theme.atlas.semantic.color.action.secondary.hoverFill;
        return `background-color: ${color};`;
      }}
    }
  }

  &:before {
    position: absolute;
    content: '';
    ${({ theme }) =>
      theme.isVaultVariant
        ? 'top: 3px;'
        : 'top: 50%; transform: translateY(-50%);'}
    left: ${({ checked }) => (checked ? '27px' : '3px')};
    transition: left 300ms;
    width: 18px;
    height: 18px;
    border-radius: 9px;
    ${({ theme }) => (theme.isVaultVariant ? '' : 'box-sizing: border-box;')}
    background-color: ${({ checked, disabled, theme }) => {
      if (theme.isVaultVariant) {
        return theme.atlas.semantic.color.action.primary.onPrimary;
      }
      if (checked) {
        return disabled
          ? theme.atlas.semantic.color.type.disabled
          : theme.atlas.semantic.color.action.primary.onPrimary;
      }
      return theme.atlas.semantic.color.surface.default;
    }};
    ${({ checked, disabled, theme }) =>
      !checked && !theme.isVaultVariant
        ? `border: 1px solid ${
            disabled
              ? theme.atlas.semantic.color.outline.disabled
              : theme.atlas.semantic.color.outline.default
          };`
        : ''}
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
`;
